import React, { useState } from 'react';
import { Button } from 'antd-mobile';
import { Modal } from 'antd';
import { BarcodeOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import Barcode from 'react-barcode';

const BarcodeButton = ({ codeList }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsChecked(true); // 用户点击同意后，设置复选框为选中状态
    setIsModalVisible(false);
  };

  return (
    <>
      <Button
        onClick={showModal}
        checked={isChecked}
        block
        className="primary-button">
        繳費條碼 <BarcodeOutlined style={{ fontSize: '18px' }} />
      </Button>

      <Modal
        closable={true}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleOk}
        maskClosable={true}
        footer={null}>
        <div
          className="text-sm font-normal text-align-center"
          style={{ margin: '-10px' }}>
          <p className="mt-8 px-2" style={{ textAlign: 'center' }}>
            請於超商櫃台出示此條碼即可繳費
          </p>
          {codeList.map((value, index) => {
            return (
              <div key={value} style={{ textAlign: 'center' }}>
                <Barcode
                  format="CODE39"
                  key={value}
                  value={value}
                  height={50}
                  width={1}
                  fontSize={12}
                />
              </div>
            );
          })}
          <div className="horizontally" style={{ textAlign: 'center' }}>
            <p>適用超商：</p>
            <div>
              <img src="/images/picture/store.svg" />
            </div>
          </div>
        </div>
      </Modal>

      {/* ANTD-Mobile Modal 太小會跑版 */}
      {/* <Modal
        showCloseButton={true}
        visible={isModalVisible}
        onOk={handleOk}
        onClose={handleOk}
        closeOnMaskClick={true}
        content={
          <div
            className="text-sm font-normal text-align-center"
            style={{ margin: '-10px' }}>
            <p className="mt-8 px-2">請於超商櫃台出示此條碼即可繳費</p>
            {codeList.map((value, index) => {
              return (
                <div key={value}>
                  <Barcode
                    format="CODE39"
                    key={value}
                    value={value}
                    height={50}
                    width={1}
                    fontSize={12}
                  />
                </div>
              );
            })}
            <div className="horizontally">
              <p>適用超商：</p>
              <div>
                <img src="/images/picture/store.svg" />
              </div>
            </div>
          </div>
        }></Modal> */}
    </>
  );
};

BarcodeButton.propTypes = {
  codeList: PropTypes.array.isRequired,
};

export default BarcodeButton;
